<template>
  <div>
    <section class="blockElement banner Cmp_guide2 pb-0">
      <div class="container" align="left">
        <div class="row flexrowreverse align-items-center">
          <div class="col-12 col-md-7">
            <img class="img-fluid" height="357" width="635" alt="Shoonya Powerful Multi Asset Platform" title="Shoonya Powerful Multi Asset Platform" src="../../../../static/website/images/shoonya_topbanner.webp"/>
          </div>
          <div class="col-12 col-md-5">
            <div class="banner_text full_width text-left">
              <h1 class="m-0">
                <span>Shoonya</span> - Powerful Multi Asset Platform
              </h1>
              <p>
                Shoonya is everything you are looking for in a trading platform
                — on the device of your choice.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--Section-->
    <section class="blockElement aboutUs pt-4">
      <div class="container">
        <div class="row text-center justify-content-center">
          <div class="col-12 col-md-11">
            <div class="bottom-shadow whiteBoard">
              <p>
                Shoonya aims to simplify investing by offering intuitive tools
                that add efficiency to your trading. Multiple charts in a single
                screen, a wide range of technical analysis tools, historical
                data, seamless account management, it offers everything you are
                looking for
              </p>
              <div class="customBtn-bt d-inline-block">
                <a
                  class="fin_btn darkBG redBtn"
                  :href="appBasePath + downloadFolderPath + 'SHOONYA.exe'"
                  target="_blank"
                  >Desktop</a
                >
                <span class="ml-3">OR</span>
                <a
                  class="fin_btn ml-3 darkBG"
                  href="http://trade.shoonya.com/"
                  target="_blank"
                  >Web</a
                >
              </div>
            </div>
            <div class="cta blob part" data-num="1">
              <img
                src="../../../../static/website/images/footer-blob1.svg"
                alt="Icon"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="blockElement darkBG edge-texture mt-5">
      <div class="container">
        <div class="row justify-content-center align-items-center">
          <div class="col-12">
            <div class="head-title text-center mb-0">
              <h2><span> Powerful</span> and easy-to-use features</h2>
            </div>
            <div class="fxFeatures">
              <ul class="features_lst">
                <li class="ls1 left">Technical & Fundamental Analysis</li>
                <li class="ls2">Multiple Time-frames</li>
                <li class="ls3">100+ Studies</li>
                <li class="ls4">Screeners & Analytics</li>
                <li class="ls5 center">Option Chain</li>
                <li class="ls6 center_bottom">Multiple Time intervals</li>
              </ul>
              <img width="1101" height="503"
                src="../../../../static/website/images/shoonya_features.webp"
                alt="features of fox trader"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="different" class="blockElement hft scalperTsection">
      <div class="container" align="center">
        <div class="head-title text-center">
          <h2>Why <span>Shoonya?</span></h2>
        </div>
        <div class="row justify-content-center">
          <div class="col-12 col-md-4 text-center fxOne">
            <div class="shadowWhite">
              <span
                ><img width="71" height="70"
                  src="../../../../static/website/images/margin-3.svg"
                  alt="Multi Assets Platform" title="Multi Assets Platform"
              /></span>
              <h3>Multi Assets Platform</h3>
              <div class="bottomAres">
                <p>
                  Trade Stocks, Derivatives (F&O), Currencies, Commodities,
                  Mutual Funds, SIP, Bonds and ETF from the platform.
                </p>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4 text-center fxOne">
            <div class="shadowWhite">
              <span
                ><img width="80" height="70" src="../../../../static/website/images/inc-6.svg"  alt="Historical Data" title="Historical Data"/></span>
              <h3>Historical Data</h3>
              <div class="bottomAres">
                <p>
                  Plan your next trade and analyse the markets with access to
                  historical trading data and multiple time intervals.
                </p>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4 text-center fxOne">
            <div class="shadowWhite">
              <span
                ><img width="80" height="70"
                  src="../../../../static/website/images/margin-6.svg"
                  alt="Advance Tools & Studies" title="Advance Tools & Studies"
              /></span>
              <h3>Advance Tools & Studies</h3>
              <div class="bottomAres">
                <p>
                  Access more than 100 technical indicators and studies that can
                  be customised to match your trading style.
                </p>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4 text-center fxOne">
            <div class="shadowWhite">
              <span
                ><img width="80" height="70"
                  src="../../../../static/website/images/iob-icon-3.svg"
                  alt="Charting tools" title="Charting tools"
              /></span>
              <h3>Charting tools</h3>
              <div class="bottomAres">
                <p>
                  Chart IQ's advanced charts and over 15 screeners in Stocks,
                  Futures & Options and price alert help traders analyze the
                  technical aspects of the market.
                </p>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4 text-center fxOne">
            <div class="shadowWhite">
              <span
                ><img width="72" height="70"
                  src="../../../../static/website/images/margin-2.svg"
                  alt="Option Chain" title="Option Chain"
              /></span>
              <h3>Option Chain</h3>
              <div class="bottomAres">
                <p>
                  Access the Option Chain to quickly manage expirations with
                  visibility to strike prices & quotes
                </p>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4 text-center fxOne">
            <div class="shadowWhite">
              <span
                ><img width="80" height="70"
                  src="../../../../static/website/images/smart.svg"
                  alt="Cross Platform" title="Cross Platform"
              /></span>
              <h3>Cross Platform</h3>
              <div class="bottomAres">
                <p>
                  Available on Desktop, web and mobile, Shoonya is built for
                  ultimate performance, flexibility and speed.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="mobileapp" class="blockElement">
      <div class="container">
        <div class="row d-flex align-items-center">
          <div class="col-12 col-md-7">
            <div class="section_title padtop100">
              <small>Reliable. Connected. Secure</small>
              <h1>
                Trade On The Go With <br />
                Shoonya Mobile App
              </h1>
            </div>
            <div class="desc">
              <p>
                Manage your account and trades on the go with Shoonya iOS and
                Andriod trading application.
              </p>
            </div>
            <div class="appstore_btn">
              <a
                href="https://apps.apple.com/us/app/shoonya/id1539034076"
                target="_blank"
                ><img width="184" height="54"
                  src="../../../../static/website/images/app-store.webp"
                  alt="app store image" title="app store image"
              /></a>
              <a
                href="https://play.google.com/store/apps/details?id=com.rs.shoonya&hl=en_IN&gl=US"
                target="_blank"
                ><img width="183" height="55"
                  src="../../../../static/website/images/google-play.webp"
                  alt="play store image" title="play store image"
              /></a>
            </div>
          </div>
          <div class="col-12 col-md-5">
            <div class="text-center">
              <div
                id="carouselExampleSlidesOnly"
                class="carousel phonevideo slide"
                data-ride="carousel"
              >
                <div class="carousel-inner">
                  <div class="carousel-item active">
                    <img width="445" height="606" alt="app screenshot 1" title="app screenshot 1"
                      src="../../../../static/website/images/mobile_video_thumb.webp"
                    />
                  </div>
                  <div class="carousel-item">
                    <img
                      src="../../../../static/website/images/mobile_video_thumb_1.webp"
                      width="445" height="606" alt="app screenshot 2" title="app screenshot 2"                     
                    />
                  </div>
                  <!-- <div class="carousel-item">
                                <img src="../../../../static/website/images/mobile_video_thumb_1.webp" alt="">
                            </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="blockElement">
      <div class="container" align="center">
        <div class="head-title text-center">
          <h2>Single Application For All <span>Exchanges</span></h2>
        </div>
        <div class="row justify-content-center">
          <div class="col-8">
            <div class="exchange_logo">
              <ul>
                <li>
                  <img width="100" height="45" alt="brand image one" title="brand image one"
                    src="../../../../static/website/images/nse_logo.webp"
                  />
                </li>
                <li>
                  <img width="105" height="45" alt="brand image one" title="brand image one"
                    src="../../../../static/website/images/bse_logo.webp"
                  />
                </li>
                <li>
                  <img width="111" height="45" alt="brand image one" title="brand image one"
                    src="../../../../static/website/images/mcx_logo.webp"
                  />
                </li>
                <li>
                  <img width="161" height="45" alt="brand image one" title="brand image one"
                    src="../../../../static/website/images/ncdex_logo.webp"
                  />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <app-seo></app-seo>
    </section>
  </div>
</template>
<script>
import SEO from "../shared/SEO";
import VueFaqAccordion from "vue-faq-accordion";
import { CheckIcon } from "vue-feather-icons";
export default {
  name: "app",
  data() {
    return {
      appBasePath: "https://shoonya.com",
      downloadFolderPath: "/downloads/",
      prismRegisterPath: process.env.PRISM_REGISTER,
      scalpertDownloadPath: process.env.SCLAPERT_DOWNLOAD,
      scalpertDownloadIosPath: process.env.SCAPERT_DOWNLOAD_IOS,
      tabs: [
        {
          name: "overview",
          displayName: "Direct Dealing from Charts",
        },
        {
          name: "about",
          displayName: "Pricing Made ZERO",
        },
        {
          name: "check",
          displayName: "Advance Tools & Studies",
        },
      ],
      activeTabName: null,
    };
  },
  components: {
    VueFaqAccordion,
    appSeo: SEO,
    CheckIcon,
  },
  methods: {
    setActiveTabName(name) {
      this.activeTabName = name;
    },
  },
  computed: {},
  mounted() {
    $(".showMore-btn").click(function () {
      $(".nodeActive").toggleClass("active");
    });
    this.activeTabName = this.tabs[0].name;
    window.scroll(0, 0);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/website/trading/shoonya.vue